export default __webpack_public_path__ + "static/media/SMSgt_updated.d4a0270d.png";